import { Expose } from 'class-transformer';
import { ProjectTransactionRelatedAgentModel } from './project-transaction-related-agent.model';

export class ProjectTransactionRelatedInternalCobrokeModel extends ProjectTransactionRelatedAgentModel {
  @Expose()
  type!: string;
}
